export default {
  file: null,
  uploading: false,
  progress: 0,
  drop: false,
  dialog: false,
  overwrite: false,
};
